// ============================================================
// constants/navItems.js — Super Admin navigation menu config
// ============================================================

import { ShieldPlus, SettingsIcon, TableConfig } from "lucide-react";

/**
 * Each item: { icon, text, page }
 * `page` matches the route segment and the switch-case in renderCurrentPage.
 */
export const navItems = [
  { icon: TableConfig,  text: "Configurations", page: "ConfigurationManagement" },
  { icon: ShieldPlus,   text: "Admin Accounts", page: "AdminAccountCreation"    },
  { icon: SettingsIcon, text: "Settings",        page: "Settings"                },
];